// extracted by mini-css-extract-plugin
module.exports = {"main":"loginOrRegister_main__Rn_fc","btnLogin":"loginOrRegister_btnLogin__uzjQA","btnRegister":"loginOrRegister_btnRegister__mOlVr"};